import { InvoiceFilters } from "@common/contracts/invoice.contract";
import { toInvoiceTaskFilters } from "@common/helpers/domains/invoices/invoiceTaskFilters";
import { FiltersTypes } from "@common/types/filters/general";

interface BuildInvoicesTaskFiltersParams {
    /** Live view filters (user filter edits, pinned ids for static tasks). */
    viewFilters: FiltersTypes;
    /** Creator-set criteria of a sticky task. Present only for sticky tasks. */
    originalFilters?: FiltersTypes;
    /** Sticky membership snapshot. Present only for sticky tasks. */
    stickyInvoiceIds?: string[];
}

/**
 * Invoice list filters behind an invoices task table, shared by the task body
 * and the creation preview. A sticky task reads its pinned membership only:
 * the criteria that decide membership (status, amounts) change when an invoice
 * is edited, so re-applying them would make acted-on rows vanish. Returns null
 * when no invoice can match, which must never fall back to "all invoices".
 */
export function buildInvoicesTaskFilters({
    viewFilters,
    originalFilters,
    stickyInvoiceIds,
}: BuildInvoicesTaskFiltersParams): InvoiceFilters | null {
    if (originalFilters !== undefined) {
        if (!stickyInvoiceIds?.length) {
            return null;
        }
        return toInvoiceTaskFilters({
            invoiceIds: stickyInvoiceIds,
            entityIds: viewFilters.entityIds,
            search: viewFilters.search,
        });
    }
    return toInvoiceTaskFilters(viewFilters);
}
